function initializeTabsSlider() {
  const allCards = document.querySelectorAll('ul.collection-tabs--media--tabs--content .tabs-products-card');
 
  function initSlider(card) {
    const $card = $(card);
    const listLength = $card.find('li').length;
 
    if (listLength > 3) {
      if (!$card.hasClass('slick-initialized')) {
        $card.slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          prevArrow: '<div class="slick-prev"><svg class="icon--icon-prev" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="m4 10l9 9l1.4-1.5L7 10l7.4-7.5L13 1z"/></svg></div>',
          nextArrow: '<div class="slick-next"><svg class="icon--icon-next" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="M7 1L5.6 2.5L13 10l-7.4 7.5L7 19l9-9z"/></svg></div>',
          responsive: [
            {
              breakpoint: 1024, 
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768, 
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
 
      requestAnimationFrame(() => {
        setTimeout(() => {
          $card.slick('setPosition');
        }, 50);
 
        setTimeout(() => {
          $card.slick('setPosition');
        }, 300);
      });
 
    } else {
      if ($card.hasClass('slick-initialized')) {
        $card.slick('unslick');
      }
    }
  }
const firstCard = allCards[0];
  initSlider(firstCard);
  document.body.addEventListener('click', function (e) {
    const tab = e.target.closest('ul.collection-tabs--media--tabs li');
    if (!tab) return;
    var activeTabHeight = $('.tabs-products-card.grid.product-grid.active').height();
    $('.tabs-products-card:not(.slick-initialized)').css('height', activeTabHeight);
   
     const tabHead = tab.getAttribute('data-attr');
    const allCards = document.querySelectorAll('ul.collection-tabs--media--tabs--content .tabs-products-card');
    const allButtons = document.querySelectorAll('.button-collections-link');
 
    // Remove active class from all tabs
    document.querySelectorAll('ul.collection-tabs--media--tabs li').forEach(tabEl => {
      tabEl.classList.remove('active');
    });
 
    // Add active class to clicked tab
    tab.classList.add('active');
 
    // Hide all cards and buttons
    allCards.forEach(card => {
      if ($(card).hasClass('slick-initialized')) {
        $(card).slick('unslick');
      }
      card.style.display = 'none';
      card.style.opacity = 0;
      card.classList.remove('active');
    });
 
    allButtons.forEach(button => {
      button.style.display = 'none';
    });
 
    // Show matching card
    const targetCard = document.querySelector(`ul.collection-tabs--media--tabs--content .tabs-products-card[data-attr='${tabHead}']`);
    if (targetCard) {
      targetCard.style.display = 'flex';
      targetCard.classList.add('active');
 
      let opacity = 0;
      const fadeIn = () => {
        opacity += 1;
        targetCard.style.opacity = opacity;
        if (opacity < 1) requestAnimationFrame(fadeIn);
      };
      requestAnimationFrame(fadeIn);
 
      initSlider(targetCard);
    }
 
    // Show matching button
    const targetButton = document.querySelector(`.button-collections-link[data-attr="${tabHead}"]`);
    if (targetButton) {
      targetButton.style.display = 'inline-flex';
    }
  });
}
$(document).ready(function () {
  initializeTabsSlider();
  
});
 
 
 
document.addEventListener('shopify:section:load', function () {
  initializeTabsSlider();
});
document.addEventListener('shopify:block:select', function () {
  initializeTabsSlider();
});
 
document.addEventListener('tabsSlider:reload', function () {
  initializeTabsSlider();
});